import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  CustomProjectManagerField,
  validateProjectManager,
} from './CustomProjectManagerField';

export const CustomProjectManagerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomProjectManagerField',
    component: CustomProjectManagerField,
    validation: validateProjectManager,
  }),
);
